/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms.generator

import io.kvision.core.Color
import io.kvision.core.FontStyle
import io.kvision.core.onEvent
import io.kvision.html.Button
import io.kvision.html.p
import io.kvision.modal.Modal
import io.kvision.modal.ModalSize
import io.kvision.utils.event

class ValidationWindow : Modal(null, false, ModalSize.XLARGE, centered = true) {

  val closeModal: Button
  var continueButton: Button

  init {
    add(p(content = "Dokument nie został poprawnie wypełniony.<br>" +
        "Wróc do edycji aby poprawić dane lub kontynuuj zapisywanie by zrobić to później", className = "text-center", rich = true) {
      this.color = Color.rgb(184, 18, 0)
    })
    closeModal = Button("Wróc do edycji", "fas fa-undo").onClick {
      this@ValidationWindow.hide()
    }
    continueButton = Button("Kontynuuj zapisywanie", "far fa-save").onClick {
      this@ValidationWindow.hide()
      DocumentFormModel.saveForm("Dokument nie został poprawnie wypełniony")
    }

    addButton(closeModal)
    addButton(continueButton)
    onEvent {
      event("shown.bs.modal") {
        closeModal.focus()
      }
    }
  }

  fun showModalDialog(error: String) {
    error.split(".,").forEach {
      this.add(p(it, className = "alert mb-0 py-1") {
        FontStyle.ITALIC
      })
    }
    this.show()
  }
}

